import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { useResizeX } from 'Hooks/useResize';
import useWindowDimensions from 'Hooks/useWindowSize';
import Wrapper from './styled';
import {
  ResizerWrapper, DetailWrapper, Resizer
} from 'Screens/Contextualization/Host/components/HostDetail/styled';
import { selectTriggerAgentId } from 'store/Agents/selectors';
import UserAgentDetail from './components/UserAgentDetail';
import { getManifest, resetDetail } from 'store/Agents/actions';

const AgentDetail = ({ setTriggerWarning }) => {
  const [showTransparency, setShowTransparency] = useState(false);
  const ref = useRef(null);
  const wrapperRef = useRef(null);
  const resizerRef = useRef(null);
  const { width } = useWindowDimensions();
  const minWidth = width < 3000 ? width * 0.55 : width * 0.35;
  const maxWidth = width < 3000 ? width * 0.75 : width * 0.55;
  const wrapperWidth = useResizeX(wrapperRef, resizerRef, minWidth, minWidth, maxWidth);
  const data = useSelector(selectTriggerAgentId);
  const dispatch = useDispatch();

  const onScroll = () => {
    const scrollTop = get(ref, 'current.scrollTop', 0);
    if (scrollTop === 0) setShowTransparency(false);
    else setShowTransparency(true);
  };

  useEffect(() => {
    dispatch(getManifest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => () => {
    dispatch(resetDetail());
  }, [dispatch]);

  return data
    ? (
    <Wrapper ref={ wrapperRef } wrapperWidth={ wrapperWidth }>
      <ResizerWrapper ref={ resizerRef } children={ <Resizer /> } />
      <DetailWrapper>
        <UserAgentDetail tabRef={ ref } onScroll={ onScroll } showTransparency={ showTransparency } setTriggerWarning={ setTriggerWarning } />
      </DetailWrapper>
    </Wrapper>
      )
    : null;
};

export default AgentDetail;
